export const formatWorkTypes = (workType: Array<{ title?: string }> | string | null | undefined) => {
  if (Array.isArray(workType)) return workType.map((item) => item.title).join(', ');
  return typeof workType === 'string' ? workType : '';
};
